// extracted by mini-css-extract-plugin
export var fadeInOut = "_12-3";
export var icon = "_12-4";
export var savedIndicator = "_12-2";
export var savingIndicator = "_12-0";
export var spin = "_12-1";